module.exports = __webpack_public_path__ + "static/media/mech-walk.967cf1d1.mp3";